/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the supplied `direcition` does not match `ltr` or `rtl`
 * @export
 * @class I18nInvalidDirectionError
 * @extends {Error}
 */
export class I18nInvalidDirectionError extends Error {
  /**
   * Creates an instance of I18nInvalidDirectionError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidDirectionError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidDirectionError`;
  }
}

/**
 * Called when the supplied `direcition` does not match `ltr` or `rtl`
 * @param {any} direction The invalid `direction`
 * @param {string} ltr The `ltr` value
 * @param {string} rtl The `rtl` value
 * @returns {never} never
 */
const throwI18nInvalidDirectionError = (direction, ltr, rtl) => {
  throw new I18nInvalidDirectionError(
    stripIndent(`
    Expected "direction" to be either "${ltr}" or "${rtl}".
    Got: "${direction}"
    `),
  );
};

export default throwI18nInvalidDirectionError;
